import React from 'react';
import { OPERATIONS_TABS, OPERATIONS_NAV_TABS } from '../utils/operationsTabs';
import StartLockedDepartmentPage from '../components/start/StartLockedDepartmentPage';

/** Locked preview of the portal Operations hub (/portal/operations). */
const OPERATIONS_UNLOCKS = {
  sops: { freePage: 'operations/sops', to: '/start/operations/sops' },
  kpis: { freePage: 'operations/kpis', to: '/start/operations/kpis' },
  'job-descriptions': {
    freePage: 'operations/job-descriptions',
    to: '/start/operations/job-descriptions',
  },
  'org-chart': { freePage: 'operations/org-chart', to: '/start/existing-org-chart' },
};

const StartOperations = () => (
  <StartLockedDepartmentPage
    title="Operations"
    tabs={OPERATIONS_NAV_TABS}
    allTabs={OPERATIONS_TABS}
    unlockMap={OPERATIONS_UNLOCKS}
  />
);

export default StartOperations;
